export const gamePanel = {
  width: 20,
  height: 30
}

export const nextPanel = {
  width: 8
}

export const levels = [
  { score: 0, duration: 1500 },
  { score: 30, duration: 1200 },
  { score: 50, duration: 1000 },
  { score: 70, duration: 800 },
  { score: 90, duration: 600 },
  { score: 120, duration: 400 },
  { score: 180, duration: 300 },
  { score: 260, duration: 200 },
  { score: 360, duration: 100 },
  { score: 500, duration: 50 }
]
